var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "grafico-dona" },
    [
      _c("apexchart", {
        attrs: { type: "donut", options: _vm.chartOptions, series: _vm.series },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }